import { Box, Button } from '@mui/material';
import styled from 'styled-components';

export const SearchInputWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  width: '100%'
});

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  marginTop: '20px !important'
});
